/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Buyers_Must_Inquire_For_PriceInputs */

const en_buyers_must_inquire_for_price = /** @type {(inputs: Buyers_Must_Inquire_For_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buyers must inquire for price`)
};

const es_buyers_must_inquire_for_price = /** @type {(inputs: Buyers_Must_Inquire_For_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los compradores deben consultar por el precio`)
};

const fr_buyers_must_inquire_for_price = /** @type {(inputs: Buyers_Must_Inquire_For_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les acheteurs doivent demander le prix`)
};

const de_buyers_must_inquire_for_price = /** @type {(inputs: Buyers_Must_Inquire_For_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käufer müssen den Preis anfragen`)
};

const ja_buyers_must_inquire_for_price = /** @type {(inputs: Buyers_Must_Inquire_For_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`購入者は価格を要問い合わせ`)
};

const zh_buyers_must_inquire_for_price = /** @type {(inputs: Buyers_Must_Inquire_For_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`买家必须询价`)
};

const ar_buyers_must_inquire_for_price = /** @type {(inputs: Buyers_Must_Inquire_For_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يجب على المشترين الاستفسار عن السعر`)
};

const id_buyers_must_inquire_for_price = /** @type {(inputs: Buyers_Must_Inquire_For_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembeli harus bertanya untuk harga`)
};

const it_buyers_must_inquire_for_price = /** @type {(inputs: Buyers_Must_Inquire_For_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gli acquirenti devono richiedere il prezzo`)
};

const ru_buyers_must_inquire_for_price = /** @type {(inputs: Buyers_Must_Inquire_For_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Покупатели должны запросить цену`)
};

const pt_buyers_must_inquire_for_price = /** @type {(inputs: Buyers_Must_Inquire_For_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compradores devem consultar o preço`)
};

const ko_buyers_must_inquire_for_price = /** @type {(inputs: Buyers_Must_Inquire_For_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구매자가 가격을 문의해야 함`)
};

/**
* | output |
* | --- |
* | "Buyers must inquire for price" |
*
* @param {Buyers_Must_Inquire_For_PriceInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const buyers_must_inquire_for_price = /** @type {((inputs?: Buyers_Must_Inquire_For_PriceInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Buyers_Must_Inquire_For_PriceInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_buyers_must_inquire_for_price(inputs)
	if (locale === "es") return es_buyers_must_inquire_for_price(inputs)
	if (locale === "fr") return fr_buyers_must_inquire_for_price(inputs)
	if (locale === "de") return de_buyers_must_inquire_for_price(inputs)
	if (locale === "ja") return ja_buyers_must_inquire_for_price(inputs)
	if (locale === "zh") return zh_buyers_must_inquire_for_price(inputs)
	if (locale === "ar") return ar_buyers_must_inquire_for_price(inputs)
	if (locale === "id") return id_buyers_must_inquire_for_price(inputs)
	if (locale === "it") return it_buyers_must_inquire_for_price(inputs)
	if (locale === "ru") return ru_buyers_must_inquire_for_price(inputs)
	if (locale === "pt") return pt_buyers_must_inquire_for_price(inputs)
	return ko_buyers_must_inquire_for_price(inputs)
});